export default __webpack_public_path__ + "static/media/dress.a9856661.svg";